import { useStaticQuery, graphql } from 'gatsby'

export const useWordPressGlossaires = () => {
  const { allWordpressWpGlossaire } = useStaticQuery(
    graphql`
      query {
        allWordpressWpGlossaire(sort: { fields: [title] }) {
          nodes {
            title
            slug
            content
          }
        }
      }
    `
  )
  return allWordpressWpGlossaire.nodes
}
